import { z } from 'zod';
export const PortalsParameterSchema = z.enum(['PORTALS_BASE_URL']);
export const PortalsParameterEnum = PortalsParameterSchema.enum;
